import { css, createGlobalStyle } from 'styled-components';

const fonts = css`
  @import url('https://fonts.googleapis.com/css2?family=Roboto:wght@300;400;500&display=swap');
`;

const FontsLoader = createGlobalStyle`${fonts}`;

export default FontsLoader;
